import { render, staticRenderFns } from "./ClienteDescuentos.vue?vue&type=template&id=5b2f6580&"
import script from "./ClienteDescuentos.vue?vue&type=script&lang=js&"
export * from "./ClienteDescuentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports